export default __webpack_public_path__ + "static/media/login_microsoft_colorido.be4cbc29.svg";